/**
 * A place to handle things for the folder box
 */
namespace appn.folderFilter {
    export let selectedFolderId: string | null = appn.emptyString;

    export let selectedItems: JQuery<HTMLElement> | null = null;

    export function init(reloadUrl: string, onAfterFolderChanged?: Function): void {
        const folderIdFromUrl = utils.getUrlParamByName('folderId');
        let value = getStateOrDefault().value;
        if (folderIdFromUrl)
            value = folderIdFromUrl;

        // Auto select the initial default filter
        setValue(value);

        $('.appnFolderFilter .appnFolderFilter-link').off().on('click', function(e) {
            e.preventDefault();
            setValue($(this).prop('id'));
        });

        // Listen for close modal
        $(document).on('hidden.bs.modal', function () {
            if (!iframe.getHost().reloadFlag)
                return;

            appn.location.navTo(reloadUrl);
        });
    }

    /**
     * Will get the date filters value from local storage or direct from UI is not in LS.
     */
    export function getStateOrDefault(): INameValuePair {
        const appnFolderFilter = $('.appnFolderFilter');
        return appn.dataTable.getStateOrDefault(appn.saveMeState.getRegisterId(appnFolderFilter), getValue());
    }

    export function getValue(): string {
        const appnFolderFilter = $('.appnFolderFilter');
        const value = appnFolderFilter.find('li.active .appnFolderFilter-link').prop('id');
        if (value === 'appnFolderFilter-all')
            return appn.emptyString;

        return value;
    }

    export function setValue(value?: string) {
        appn.dataTable.uncheckAllRowsBox();
        selectedFolderId = !value || value === 'appnFolderFilter-all' ? appn.emptyString : value;

        if (getValue() === value)
            return; // No need to set if already the same

        // Set the active class
        const appnFolderFilter = $('.appnFolderFilter');
        appnFolderFilter.find('li').removeClass('active');
        appnFolderFilter.find('#' + (!value ? 'appnFolderFilter-all' : value)).closest('li').addClass('active');
    }

    export function reset() {
        setValue();
    }

    export function showDialog($organiseBtn: JQuery<HTMLElement>, title?: string): void {
        if (ui.isElementDisabled($organiseBtn))
            return;

        // Set selected Items
        selectedItems = $('.selectRow:checked');

        let organiseUrl = appn.urls.folders.organise + '/' + selectedFolderId;
        if (!selectedFolderId)
            organiseUrl += '00000000-0000-0000-0000-000000000000';

        appn.iframe.openModal({ url: organiseUrl, title: title });
    }

    export function listContains(value: string) {
        let exists = false;
        const templates = $('.appnFolderFilter .appnFolderFilter-link');
        $(templates).each((function(this: any): boolean {
            if ((this).id === 'appnFolderFilter-all')
                return true;

            if ((this).id === value) {
                exists = true;
                return false;
            }

            return true;
        } as any));

        return exists;
    }

    export function initLinkedFolders() {
        $('.linkedFolders .closeCell').click(function(event): void {
            event.preventDefault();
            appn.folderFilter.removeItemFromFolder($(this));
        });
    }

    export function removeItemFromFolder(htmlElement: JQuery<HTMLElement>) {
        // entityId should be the 'Key' not the 'Id' for any entity that controls versioning
        // eg: Screens and Documents.
        const entityId = htmlElement.attr('data-entity-id');
        const folderId = htmlElement.attr('data-folder-id');
        const folderName = htmlElement.attr('data-folder-name');
        const folderType = htmlElement.attr('data-folder-type');

        appn.dialog.confirm({
            modalColor: 'modal-danger',
            title: T('Remove From Folder'),
            message: T(`Are you sure you want to delete this Item from the folder '{0}'?`, folderName),
            buttons: {
                confirm: {
                    label: '<span>' + T('OK') + '</span>',
                    className: 'btn-success'
                }
            },
            callback: function(result: boolean) {
                if (!result)
                    return;

                appn.ajax.post({
                    url: appn.urls.folders.removeItem,
                    data: {
                        folderId: folderId,
                        entityId: entityId,
                        folderType: folderType
                    },
                    done: function() {
                        appn.location.reloadCurrentPage();
                    },
                    fail: function() {
                        appn.toast.notify(toast.Type.error, T('Failed to remove object from folder.'));
                    }
                });
            }
        });

    }

    export enum FolderEntity {
        Screen,
        Doc,
        DataSource,
        Folder,
        TaskTemplate,
        Dashboard,
        Sync
    }
}
